var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDreadknightWeapon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 55 8",
    shapeRendering: "crispEdges",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#d3d3dc",
    d: "M12 0h29M6 1h35M3 2h9M0 3h6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#36363f",
    d: "M12 2h27M6 3h32M52 5h2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#5d5d65",
    d: "M39 2h2M52 2h2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#4b4b53",
    d: "M38 3h3M52 3h3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#745e46",
    d: "M41 3h1M43 3h1M45 3h1M47 3h1M49 3h1M51 3h1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#887055",
    d: "M42 3h1M44 3h1M46 3h1M48 3h1M50 3h1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#b3b3bd",
    d: "M0 4h6M3 5h9M6 6h35M12 7h29"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#282832",
    d: "M6 4h32M12 5h27"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3c3c44",
    d: "M38 4h3M52 4h3M39 5h2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    stroke: "#2d2318",
    d: "M41 4h1M43 4h1M45 4h1M47 4h1M49 4h1M51 4h1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1e1710",
    d: "M42 4h1M44 4h1M46 4h1M48 4h1M50 4h1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDreadknightWeapon);
export default __webpack_public_path__ + "static/media/dreadknight-weapon.736da5da21df8ca500abebd1910350b2.svg";
export { ForwardRef as ReactComponent };